import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux/store';
import { Sidebar } from '../../components/Sidebar';
import { SearchResultsContainer } from '../SearchResultsContainer';
import { selectIsOpen } from '../../selectors/searchResults';
import { closeSearchResultsSidebar } from '../../actions/searchResults';

export const SidebarContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsOpen);
  const resultsVersion = useSelector<IApplicationState, Symbol | undefined>(state => state.results.version);

  const handleClose = React.useCallback(() => dispatch(closeSearchResultsSidebar()), [dispatch]);

  React.useEffect(() => {
    dispatch(closeSearchResultsSidebar());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultsVersion]);

  return (
    <Sidebar opened={isOpen} onClose={handleClose}>
      <SearchResultsContainer />
    </Sidebar>
  );
};

SidebarContainer.displayName = 'SidebarContainer';
